import { render, staticRenderFns } from "./IconSmartHome.vue?vue&type=template&id=7b54be67&scoped=true&"
import script from "./IconSmartHome.vue?vue&type=script&setup=true&lang=ts&"
export * from "./IconSmartHome.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b54be67",
  null
  
)

export default component.exports